import MuiTableRow, { TableRowProps as MuiTableRowProps } from '@mui/material/TableRow';

export type TableRowProps = MuiTableRowProps;

export const TableRow = (props: TableRowProps) => {
  return <MuiTableRow {...props} />;
};
